export default __webpack_public_path__ + "a1de12fbeda5f4cadc1c0cec27c01014.png";